var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"cls-1","d":"M22.6 26A14.3 14.3 0 1 1 6 2.6 14.4 14.4 0 0 1 26 6a14.1 14.1 0 0 1 0 16.6l9.4 9.4a2.3 2.3 0 0 1 0 3.4 2.3 2.3 0 0 1-3.4 0c0-.2-9.4-9.4-9.4-9.4Zm-8.2-.8a11 11 0 0 0 11-11 10.8 10.8 0 0 0-11-11 11 11 0 0 0-11 11 11.1 11.1 0 0 0 11 11Z","style":{"fill":"currentColor","fillRule":"evenodd"}}));
}

Search.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 36.2 36.2"};

module.exports = Search;

Search.default = Search;
